/**
 * Create by Alex
 * Description:
 *
 * ------ maintenance history ------
 * 2025/5/12 added to support impacted web notification
 */

import { businessConstants } from '../constants/business.constants';

export class ImpactedWebNotificationConfig {
    name: string;
    type: string;
    setting: string;

    /**
     * Parse the impacted web notifications from response
     * @param serverResponse
     * @returns A array of impacted web notifications
     */
    static parse(serverResponse): Array<ImpactedWebNotificationConfig> {
        const serverRes = serverResponse['reminderList'];
        if (!serverRes) {
            return null;
        }
        const impactedWebNotificationConfig: Array<ImpactedWebNotificationConfig> = new Array<ImpactedWebNotificationConfig>();

        if (serverRes && serverRes.length > 0) {
            serverRes.forEach(item => {
                impactedWebNotificationConfig.push(
                    {
                        name: item.name,
                        type: businessConstants.impactedConfigType.notificationService,
                        setting: item.field
                    }
                );
            });
        }
        return impactedWebNotificationConfig;
    }
}
